// @ts-ignore
import React from "react";

import { CONFLUENCE_PRODUCT_KEY } from "@/analytics/mappings/dataProductKey.ts";
import { BuyNowButtonExperiment } from "@/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/buy-now-button.tsx";
import { useDirectBuyExperiment } from "@/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/use-direct-buy-experiment.tsx";

import {
    CONFLUENCE_DEFAULT_UNIT_COUNT,
    confluenceOfferingSkus
} from "../configs";
import { useSelector } from "../hooks.ts";
import { getBillingCycle, getPricePlanId, getUnitCount } from "../selectors.ts";

export interface UseConfluenceDirectBuyExperimentProps {
    sku: string;
}

export function useConfluenceDirectBuyExperiment(
    props: UseConfluenceDirectBuyExperimentProps
) {
    const { sku } = props;

    const billingCycle = useSelector(getBillingCycle);
    return useDirectBuyExperiment(
        billingCycle,
        sku,
        Object.values(confluenceOfferingSkus).includes(
            // @ts-ignore
            sku as keyof confluenceOfferingSkus
        )
    );
}

export interface ConfluenceDirectBuyButtonProps {
    sku: string;
    edition: "standard" | "premium";
}

export const ConfluenceDirectBuyButton = (
    props: ConfluenceDirectBuyButtonProps
) => {
    const { sku, edition } = props;

    const pricingPlanId = useSelector((ctx) =>
        getPricePlanId(ctx, {
            offeringSku: sku,
            edition
        })
    );
    const unitCount = useSelector(getUnitCount);

    let planName;
    if (edition === "standard") {
        planName = "Standard";
    }
    if (edition === "premium") {
        planName = "Premium";
    }

    if (!pricingPlanId || !planName) {
        return null;
    }

    return (
        <BuyNowButtonExperiment
            defaultUnitCount={CONFLUENCE_DEFAULT_UNIT_COUNT}
            unitCount={unitCount}
            pricingPlanId={pricingPlanId}
            edition={edition}
            dataProductKey={CONFLUENCE_PRODUCT_KEY}
            planName={planName}
        />
    );
};
